module.exports = __webpack_public_path__ + "img/highlights-2.49383a28.svg";